import { useQuery } from '@tanstack/react-query'
import { apiRequest, Command, PaginatedResponse } from '../services/api'

export function CommandsPage() {
  const { data: commands, isLoading } = useQuery({
    queryKey: ['commands'],
    queryFn: () =>
      apiRequest<PaginatedResponse<Command>>('/api/v1/commands'),
  })
  
  if (isLoading) {
    return <div className="flex items-center justify-center h-64">Loading...</div>
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Commands</h1>
          <p className="text-gray-600">Send commands to devices</p>
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Command</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Device</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Completed</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Retries</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {commands?.data?.map((command: Command) => (
              <tr key={command.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{command.command}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {command.device_id.slice(0, 8)}...
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    command.status === 'completed' ? 'bg-green-100 text-green-800' :
                    command.status === 'failed' ? 'bg-red-100 text-red-800' :
                    command.status === 'processing' ? 'bg-blue-100 text-blue-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {command.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {command.completed_at ? new Date(command.completed_at).toLocaleString() : '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {command.retries}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {!commands?.data?.length && (
          <div className="px-6 py-12 text-center text-gray-500">
            No commands sent yet
          </div>
        )}
      </div>
    </div>
  )
}
